import noPermission from './no-permission'

const install = function(Vue) {
  Vue.directive('no-permission', noPermission)
}

if (window.Vue) {
  window['no-permission'] = noPermission
  Vue.use(install); // eslint-disable-line
}

noPermission.install = install
export default noPermission
